import { render, staticRenderFns } from "./ModalAsignarProductosACarritoComponent.vue?vue&type=template&id=675aeaa6&"
import script from "./ModalAsignarProductosACarritoComponent.vue?vue&type=script&lang=js&"
export * from "./ModalAsignarProductosACarritoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports